import { formatDateParam, makeRequest } from "../lib/makeRequest";

export const customer_profile_overall_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };
  return makeRequest("/customer-profiles/overall", params);
};

export const customer_profile_cluster_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };

  return makeRequest(`/customer-profiles/cluster/${data.clusterId}`, params);
};

export const customer_profile_area_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };

  return makeRequest(`/customer-profiles/area/${data.areaId}`, params);
};

export const customer_profile_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();

  if (data.isRange) {
    urlParams.append("from", formatDateParam(data.dates.from));
    urlParams.append("to", formatDateParam(data.dates.to));
  } else {
    urlParams.append("coveredDate", formatDateParam(data.covered_date));
  }

  return makeRequest(
    `/customer-profiles/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
